/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S10_Li1_DescInputs */

const tr_iade_iptal_s10_li1_desc = /** @type {(inputs: Iade_Iptal_S10_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam veritabanı dökümü (siparişler, ürünler, müşteri kayıtları, ayarlar).`)
};

const en_iade_iptal_s10_li1_desc = /** @type {(inputs: Iade_Iptal_S10_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full database dump (orders, products, customer records, settings).`)
};

const de_iade_iptal_s10_li1_desc = /** @type {(inputs: Iade_Iptal_S10_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständiger Datenbankauszug (Bestellungen, Produkte, Kundendatensätze, Einstellungen).`)
};

const ru_iade_iptal_s10_li1_desc = /** @type {(inputs: Iade_Iptal_S10_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полная выгрузка базы данных (заказы, товары, записи о клиентах, настройки).`)
};

/**
* | output |
* | --- |
* | "Full database dump (orders, products, customer records, settings)." |
*
* @param {Iade_Iptal_S10_Li1_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s10_li1_desc = /** @type {((inputs?: Iade_Iptal_S10_Li1_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S10_Li1_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s10_li1_desc(inputs)
	if (locale === "de") return de_iade_iptal_s10_li1_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s10_li1_desc(inputs)
	return tr_iade_iptal_s10_li1_desc(inputs)
});